import React from 'react';
import AuthService from './authService';
import TpSurveyItem from '../Domain/TpSurveyItem';
import ProjectAssociableTpSurveyItem from '../Domain/ThirdParty/Project/ProjectAssociableTpSurveyItem';
import SearchParams from '../Elements/SearchParams';
import TpSurveySearchParams from '../Contents/ThirdParty/TpSurvey/TpSurveySearchParams';

export default class TpSurveyService extends React.Component {
  static GetTpSurveyItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpSurveySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/TpSurvey/GetItems?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  // Returns the TpSurveys for a client within a given third-party system (TpInstance).
  static GetTpSurveysByClientAndInstance(clientId, tpInstanceId) {
    const searchItem = {
      ClientId: clientId,
      TpInstanceId: tpInstanceId,
    };
    const url = `/api/TpSurvey/GetTpSurveysByClientAndInstance?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetSurveySelectList(
    surveyId,
    clientIdFilter,
    projectIdFilter,
    opportunityIdFilter,
    surveyIdFilter,
    tpProjectIdFilter,
    tpSurveyIdFilter
  ) {
    const searchItem = {
      ClientId: clientIdFilter,
      ProjectId: projectIdFilter,
      OpportunityId: opportunityIdFilter,
      SurveyId: surveyIdFilter,
      TpProjectId: tpProjectIdFilter,
      TpSurveyId: tpSurveyIdFilter,
    };

    let url = '/api/TpSurvey';

    if (surveyId != null && surveyId !== -1) {
      url += `/GetSurveyById/${surveyId}?clearCache=true`;
    } else {
      url += `/GetSurveySelectList?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    }

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static AssociateProjectTpSurvey(item) {
    const url = '/api/TpSurvey/AssociateProjectTpSurvey';
    return AuthService.getInstance().CallBackendFunctionPost(url, item);
  }

  static ActivateDeacivateSurvey(tpSurveyItem) {
    // const tpSurvey = new TpSurveyItem();
    // tpSurvey.TpSurveyId = tpSurveyId;
    // tpSurvey.IsActivated = false;
    // tpSurvey.BravoClientId = clientId;
    const authService = AuthService.getInstance();
    const url = '/api/TpSurvey/DeactivateSurvey/';
    const dataJson = JSON.stringify(tpSurveyItem);

    return authService.CallBackendFunctionPut(url, dataJson);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpSurveyItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertToProjectAssociableTpSurveyItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ProjectAssociableTpSurveyItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static RemoveSurveyAssociation(item) {
    const authService = AuthService.getInstance();
    const url = '/api/TpSurvey/RemoveSurveyAssociation/';
    const dataJson = JSON.stringify(item);

    return authService.CallBackendFunctionPut(url, dataJson);
  }
}
